import {
  Activity,
  Baby,
  Bandage,
  Droplets,
  HeartPulse,
  PackageCheck,
  Pill,
  Shield,
  Stethoscope,
  Syringe,
  Wind,
  type LucideIcon,
} from 'lucide-react';

/** The catalog has no images: each kit gets an icon for its clinical area (presentation only). */
const ICON_BY_KIT: Readonly<Record<string, LucideIcon>> = {
  'KIT-RESP-ADULTO': Wind,
  'KIT-PEDIA-FEBRIL': Baby,
  'KIT-CURACION': Bandage,
  'KIT-CARDIO-BASICO': HeartPulse,
  'KIT-DIABETES': Droplets,
  'KIT-ANALGESIA': Pill,
  'KIT-ATB-IV': Syringe,
  'KIT-VACUNA-INFLU': Shield,
  'KIT-GASTRO': Activity,
  'KIT-DERMATO': Stethoscope,
};

export function iconForKit(sku: string): LucideIcon {
  return ICON_BY_KIT[sku] ?? PackageCheck;
}
